import React, { Component } from 'react'
import axios from 'axios'

class Screen1 extends Component {

  state = {
    check: false,
    email: '',
    uid: ''
  }

  openCheck = () => {
    this.setState({check: true})
  }

  addValue = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  submit = () => {
    const app = this
    const { language, t } = this.props
    let dontSubmit = false

    if(this.state.email === '') {
      dontSubmit = true
      this.setState({emailError: true})
    } else {
      this.setState({emailError: null})
    }

    if(this.state.uid === '') {
      dontSubmit = true
      this.setState({uidError: true})
    } else {
      this.setState({uidError: null})
    }

    if(!dontSubmit){
      axios.post('https://dostajemrznje.org/api/check', {
        email: this.state.email,
        uid: this.state.uid
      })
      .then(function (response) {
        if(response.data.status !== 'ok') {
          alert(t(language, 'invalidSubmission'))
        } else {
          app.setState({check: false, email: '', uid: ''})
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }


  render() {

    const { goNext, language, t } = this.props

    const start = <main>
      <p><strong>{t(language, 'welcome')}</strong></p>
      <button className="orange round" onClick={() => goNext()}>{t(language, 'reportHate')}</button>
      <button className="orange round smaller" onClick={() => goNext(1,2)}>{t(language, 'reportHateCrime')}</button>
      <button className="blue square text-hover text-hover-fill-opening-horizontal" onClick={() => this.openCheck()}>{t(language, 'checkStatus')}</button>
    </main>

    const check = <main>
      <div style={{textAlign: 'right', marginTop: 20}}><button className="red small_square" onClick={() => this.setState({check: false})}>{t(language, 'closeButton')}</button></div>
      <p><strong>{t(language, 'checkStatusDescription')}</strong></p>
      <label>{t(language, 'emailLabel')}
        <input type="text" name="email" className={this.state.emailError ? "has_error" : null} onChange={(e) => this.addValue(e)} />
      </label>
      <label>{t(language, 'caseNumberLabel')}
        <input type="text" name="uid" className={this.state.uidError ? "has_error" : null} onChange={(e) => this.addValue(e)} />
      </label>
      <button className="black square" onClick={() => this.submit()}>{t(language, 'sendButton')}</button>
    </main>

    return this.state.check ? check : start
  }
}

export default Screen1;
